import { NervaUserData, UserData } from 'hydra-data-types';

// These values should match the `GAD7ScreenName` and `PHQ9ScreenName` values.
// They get converted to the right keys within `MedicareAccessSymptomUtils.ts`.
export type MedicareAccessUserData = Partial<{
  'gad7.nervous': string[];
  'gad7.stopWorrying': string[];
  'gad7.worryTooMuch': string[];
  'gad7.troubleRelaxing': string[];
  'gad7.restless': string[];
  'gad7.annoyed': string[];
  'gad7.afraid': string[];
  'phq9.littleInterest': string[];
  'phq9.feelingDown': string[];
  'phq9.troubleSleeping': string[];
  'phq9.feelingTired': string[];
  'phq9.poorAppetite': string[];
  'phq9.feelingBad': string[];
  'phq9.troubleConcentrating': string[];
  'phq9.slowOrFast': string[];
  'phq9.selfHarm': string[];
  'phq9.harmOthers': string[];
  medicareAccessHealthCover: string[];
  medicareAccessDirectHealthCover: string[];
  medicareAccessState: string[];
  medicareAccessStateNoAddress: string[];
  medicareAccessConsent: string[];
  legalGivenName: string;
  legalFamilyName: string;
  residentialAddress: string;
  medicareAccessExclusion: string[];
  medicareBeneficiaryId: string;
  isMedicareAccess: boolean;
}>;

type SplitGISymptomsUserData = Partial<{
  lowerGISymptoms: string[];
  upperGISymptoms: string[];
}>;

/**
 * US under-65 and AU insurance coverage flow answers (screen names double as keys; the address is
 * one key per component), plus the partner-insurer access fields. Typed in hydra-data-types on
 * NervaUserData; picked here because `UserData` is a union across products.
 */
type CoverageUserData = Pick<
  NervaUserData,
  | 'coveragePlanType'
  | 'coverageUsEmployer'
  | 'coverageEmployerOutreachConsent'
  | 'coverageBenefits'
  | 'coverageAddressNotFound'
  | 'coverageCheckAuthorization'
  | 'coverageAssignmentOfBenefits'
  | 'coverageSelfPay'
  | 'coverageNoPrivateInsurance'
  | 'coverageMemberId'
  | 'insuranceCoverageCheckId'
  | 'coverageAddressLine1'
  | 'coverageAddressLine2'
  | 'coverageAddressCity'
  | 'coverageAddressState'
  | 'coverageAddressPostalCode'
  | 'coverageAddressPlaceId'
  | 'coverageAddressFormatted'
  | 'usedPartnerInsurance'
  | 'partnerInsurer'
  | 'partnerInsurerMemberId'
>;

export type UserDataState = UserData &
  MedicareAccessUserData &
  SplitGISymptomsUserData &
  CoverageUserData;

export const INITIAL_USER_DATA_STATE: UserDataState = {};
